import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { sevenNetPageMeta, sevenNetSchema } from 'components/common/schema'
import Template from 'components/cases/sevennet'

const Sevennet: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...sevenNetPageMeta} />
      <JsonLd data={sevenNetSchema} />
      <Template />
    </>
  )
}

export default Sevennet
